module.exports = __webpack_public_path__ + "img/badge_color_hs-academic.42f1a544.svg";